import { render, staticRenderFns } from "./LoanCommentsTab.vue?vue&type=template&id=18714bd2"
import script from "./LoanCommentsTab.vue?vue&type=script&lang=js"
export * from "./LoanCommentsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports